(() => {
  const TITLE = "new arrivals";
  const MOBILE_MQ = "(max-width: 749px)";

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function findNewArrivalsSection() {
    const headings = Array.from(document.querySelectorAll("h1,h2,h3"));
    const h = headings.find(el => el.textContent.trim().toLowerCase() === TITLE);
    if (!h) return null;
    return h.closest("section, .shopify-section, [id^='shopify-section-']") || null;
  }

  function getSwiperRoot(section) {
    // Release usually uses a web component OR a .swiper root
    return section.querySelector("swiper-component") || section.querySelector(".swiper");
  }

  function getSwiperInstance(root) {
    return root?.swiper || root?.__swiper || null;
  }

  function enableNativeMobileScroll(section) {
    // Mark section for CSS
    section.classList.add("na-native-scroll");

    // If Swiper exists, destroy it on mobile (so it stops overriding touch)
    const root = getSwiperRoot(section);
    const swiper = getSwiperInstance(root);

    if (swiper && !swiper.destroyed) {
      try {
        swiper.destroy(true, true);
      } catch (e) {
        // If destroy fails, we still apply CSS-native scroll
      }
    }
  }

  function disableNativeMobileScroll(section) {
    section.classList.remove("na-native-scroll");
    // Optional: if you want Swiper back when resizing to desktop,
    // the theme usually re-initializes on reload. Keep it simple:
    // do nothing here.
  }

  function apply() {
    const section = findNewArrivalsSection();
    if (!section) return;

    if (isMobile()) enableNativeMobileScroll(section);
    else disableNativeMobileScroll(section);
  }

  document.addEventListener("DOMContentLoaded", apply);
  document.addEventListener("shopify:section:load", apply);
  window.addEventListener("resize", apply, { passive: true });
})();
